import React from 'react'
import ReactDOM from 'react-dom/client'
import LoadingContext from 'context/LoadingContext'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import ToastContext from 'context/ToastContext'
import App from './App'
import reportWebVitals from './reportWebVitals'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <ToastContext>
    {/* toast should wrap loading */}
    <LoadingContext>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LoadingContext>
  </ToastContext>,
  // </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
